/**
 * Storage identifiers of the per-user list filter persistence (see FilterStateService).
 * Every list page owns exactly one key. They end up in the localStorage record name,
 * so keep them stable - renaming one silently drops the users' saved filters.
 */
export const FilterPageKeys = {
  Subscriptions: 'subscriptions',
  LicenseUsageLogs: 'license-usage-logs',
  Accounts: 'accounts',
  Billing: 'billing',
  Notifications: 'notifications',
  TenantManagement: 'tenant-management',
  LicenseUsageReports: 'license-usage-reports',
  Users: 'users',
} as const;

export type FilterPageKey = (typeof FilterPageKeys)[keyof typeof FilterPageKeys];

/** Common prefix of every persisted filter record. */
export const FILTER_STATE_KEY_PREFIX = 'ldm.filters';

/**
 * True when the given localStorage key belongs to the filter persistence.
 * Shared by FilterStateService (clearAll) and BrowserSessionService (new session wipe)
 * so both agree on what "a filter record" is.
 */
export function isFilterStateKey(key: string | null | undefined): boolean {
  return !!key && key.startsWith(`${FILTER_STATE_KEY_PREFIX}.`);
}
